import React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useAnimations } from "../../Logic/Animations";
import PlansCard from "../PlansCard";
import PlansCardImage from "../PlansCardImage";
import Style from "./PlansCardStack.module.scss";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/scss";
import "swiper/swiper-bundle.min.css";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import "swiper/css/autoplay";
import { useDimensions } from "../../Logic/Dimensions";

const PlansCardStack = ({
  plansData,
  buttonText,
  cardType,
  buttonCallback,
  isLoading,
}) => {
  const { userProfileData,status } = useSelector((state) => state.userData);
  const { slideTopRef } = useAnimations();
  const location = useLocation();
  const { width } = useDimensions();
  // shimmer
  if (isLoading) {
    return (
      <>
        <div
          className={`${Style.PlansCardStack__cards__cardSingle} anim load-anim`}
        >
          {[...Array(width < 768 ? 1 : 2)].map((_, i) => (
            <div
              key={i}
              className={`${Style.PlansCard} ${Style.PlansCard_loading} ${Style.main} plans-card shimmer-loader`}
            ></div>
          ))}
        </div>
      </>
    );
  }

  const PlansCardWrapper = () => {
    return (
      <>
        {(plansData?.length == 2 && width > 980) ||
        (plansData?.length == 1 && width > 980) ||(plansData?.length >0 && width < 576) ? (
          plansData?.map((item, index) => (
            <>
              <PlansCard
                index={index}
                data={item}
                buttonText={buttonText}
                type={cardType}
                buttonCallback={(plan) => buttonCallback(plan, "Plan")}
              />
            </>
          ))
        ) : (
          <Swiper
            // slidesPerView={2}
            spaceBetween={30}
            loop={true}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              640: {
                slidesPerView: 1,
                spaceBetween: 30,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 30,
              },
              1200: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
            }}
            modules={[Autoplay, Pagination, Navigation]}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            speed={1200}
          >
            {plansData
              ? plansData?.map((item, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <div
                        className={`${
                          plansData?.length == 1
                            ? Style.PlansCardStack__cardSingle
                            : Style.PlansCardStack__cardWrap
                        } ${item.recommended ? Style.plan_recommended : ""}`}
                        // Styles={{ flexWrap: "none" }}
                        key={item.id}
                        ref={slideTopRef}
                      >
                        <PlansCard
                          data={item}
                          buttonText={buttonText}
                          type={cardType}
                          buttonCallback={buttonCallback}
                        />
                      </div>
                    </SwiperSlide>
                  );
                })
              : [1, 2, 3].map((item, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <div
                        className={`${Style.PlansCardStack__cardWrap} data-loading`}
                        key={index}
                        ref={slideTopRef}
                      >
                        <div className={`${Style.PlansCard} plans-card`}>
                          <div className={Style.PlansCard__top}>
                            <div
                              className={`${Style.plan_duration} plan-duration`}
                            ></div>
                            <h4 className={`${Style.plan_amount} plan-amount`}>
                              <span className={Style.plan_amount_value}></span>{" "}
                            </h4>
                            <p
                              className={`${Style.plan_description} plan-description`}
                            >
                              <span className={Style.lines}></span>
                              <span className={Style.lines}></span>
                              <span className={Style.lines}></span>
                            </p>
                            <ul
                              className={`${Style.plan_features} plan-features`}
                            >
                              <li></li>
                              <li></li>
                              <li></li>
                            </ul>
                          </div>
                          <div
                            className={`${Style.PlansCard__button} plans-card-button`}
                          ></div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
          </Swiper>
        )}
      </>
    );
  };

  return (
    <div
      className={`${`${Style.PlansCardStack}`} ${
        location.pathname === "/plans" || location.pathname === "/"
          ? userProfileData.plan_payment_status === 1 && !userProfileData?.is_package   && "payment_done"
          : ""
      } `}
    >
      <div
        className={`${
          plansData?.length <= 2
            ? Style.PlansCardStack__cards__cardSingle
            : Style.PlansCardStack__cards
        } anim load-anim`}
      >
        {plansData?.length == 1 ? (
          <>
            <PlansCardImage
              className={location.pathname === "/" ? Style.PlansCard_image : ""}
            />
          </>
        ) : (
          <></>
        )}

        {(location.pathname === "/plans" || location.pathname === "/")&& !userProfileData?.is_package  
          ? userProfileData.plan_payment_status === 0 ||userProfileData.plan_payment_status === undefined ? PlansCardWrapper() : "" : PlansCardWrapper()}
      </div>
    </div>
  );
};

export default PlansCardStack;
